module.exports = __webpack_public_path__ + "static/media/tick-disabled.bffa68ba.svg";